module.exports = __webpack_public_path__ + "static/img/荣誉_05@2x.c80e8c65.png";